<template>
  <ViewContainer :title="$t('menu.admin.organization_logs')">
    <LogsTable
      :columnsEnabled="columnsEnabled"
      :filtersEnabled="filtersEnabled"
      @updateTable="getLogs"
    />
  </ViewContainer>
</template>

<script>
import ViewContainer from '@/components/Core/Layout/ViewContainer.vue'
import LogsTable from './LogsTable.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'OrganizationAdminLogs',

  components: {
    LogsTable,
    ViewContainer,
  },

  data() {
    return {
      modalStatus: false,
      columnsEnabled: [
        'eventName',
        'eventTime',
        'sourceAccountId',
        'sourceAccountName',
        'sourceOrganizationId',
        'sourceAccountIP',
        'eventDescription',
        'userAgent',
        'userAgentVersion',
        'responseType',
        'targetAccountId',
        'targetType',
        'targetId',
        'targetOrganizationId',
      ],
      filtersEnabled: [
        'eventName',
        'sourceAccountId',
        'targetAccountId',
        'targetType',
        'targetId',
      ],
    }
  },

  created() {
    this.getLogs()
  },
  computed: {
    ...mapGetters(['organizationId']),
  },
  methods: {
    ...mapActions(['getOrganizationAuditLogs']),
    getLogs() {
      return this.getOrganizationAuditLogs({
        organizationId: this.organizationId,
      })
    },
  },
}
</script>
